import React from "react";
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, Radar, PolarRadiusAxis, Tooltip } from "recharts";
import { useApp } from "@/context/AppContext";

// Animated radar — the signature Archedia Perspective visual.
export const RadarPerspective = ({ data, height = 340, colors, secondName }) => {
  const { theme } = useApp();
  const dark = theme === "dark";
  const gridColor = dark ? "#2A4F42" : "#E3E4E2";
  const tickColor = dark ? "#B4C4BA" : "#66756D";
  const gold = "var(--accent-gold)";
  const second = colors?.[1] || (dark ? "#5BA88A" : "#0D2B21");

  return (
    <div data-testid="radar-perspective" className="w-full">
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke={gridColor} />
          <PolarAngleAxis dataKey="criterion" tick={{ fill: tickColor, fontSize: 11 }} />
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <Tooltip
            contentStyle={{
              background: dark ? "#123629" : "#FFFFFF",
              border: `1px solid ${gold}`,
              borderRadius: 12,
              color: dark ? "#F5F3ED" : "#0D2B21",
              fontSize: 12,
            }}
          />
          <Radar name="Archedia Index" dataKey="value" stroke={gold} fill={gold} fillOpacity={0.28} strokeWidth={2} animationDuration={1400} />
          {secondName && (
            <Radar name={secondName} dataKey="value2" stroke={second} fill={second} fillOpacity={0.14} strokeWidth={2} animationDuration={1400} />
          )}
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadarPerspective;
